/**
 * @module app.bdc.reports.bdcNAPServicesCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function BDCNAPServicesCtrl($scope, $window, $rootScope, pricesService, orderService, offerService) {
        var self = {};
        self.orderForm = $rootScope.orderForm;
        self.user = $rootScope.user;

        if (!self.orderForm) {
            return $scope.goTo('/list');
        }

        self.order = $rootScope.order;
        pricesService.setOrderForm(self.orderForm);
        pricesService.setOrder(self.order);

        self.isRental = orderService.isRental(self.order.contract.contractType.code);
        self.contractMonths = orderService.getContractMonths(self.order);
        self.isOlderOffer = offerService.isOlderOffer(self.order);

        /**
         * Get the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            return moment().format('DD/MM/YYYY');
        };

        /**
         * Get installation date if defined
         * @return {String}
         */
        self.getDateInstallation = function getDateInstallation() {
            return self.order.dateInstallation
                ? moment(self.order.dateInstallation, 'YYYY-MM-DD').format('MMMM YYYY')
                : null;
        };

        return self;
    }

    BDCNAPServicesCtrl.$inject = ['$scope', '$window', '$rootScope', 'pricesService', 'orderService', 'offerService'];

    angular.module('app.bdc.reports.bdcNAPServicesCtrl', []).controller('BDCNAPServicesCtrl', BDCNAPServicesCtrl);
});
